import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_5 = { key: 0 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_7 = { key: 1 }

import { computed, onMounted, ref } from 'vue'
import { authStore } from '@/stores/auth'
import axios from 'axios'
import { useRouter } from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'IssuesWidget',
  setup(__props) {

const auth = authStore()
const router = useRouter()
const screenWidth = computed(() => window.innerWidth)

const baseColumns = [
  {
    title: '#',
    dataIndex: 'id',
    key: 'id'
  },
  {
    title: 'Melding',
    dataIndex: 'title',
    key: 'title'
  },
  {
    title: 'Object',
    dataIndex: 'building',
    key: 'building'
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status'
  },
  {
    title: 'Actie\'s',
    dataIndex: 'actions',
    key: 'actions'
  }
]

const issues = ref([])
const loading = ref(false)

const columns = computed(() => {
  const columns = baseColumns
  if (!auth.multipleObjects) {
    columns.splice(2, 1)
  }

  return columns
})

onMounted(() => {
  getIssues()
})

function getIssues () : void {
  loading.value = true
  axios.get(process.env.VUE_APP_API_URL + '/issues?filter[building.id]=' + auth.buildingIds.join(',') + '&sort=-id&limit=250').then((res) => {
    issues.value = res.data.data
  }).finally(() => {
    loading.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    title: "Servicemeldingen",
    bordered: false,
    loading: loading.value
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'IssueCreate' })))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Toevoegen")
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_unref(screenWidth) >= 768)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            class: "mb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  (issues.value.length)
                    ? (_openBlock(), _createBlock(_component_a_table, {
                        key: 0,
                        dataSource: issues.value,
                        columns: _unref(columns),
                        pagination: { pageSize: 5 },
                        scroll: { x: true }
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.key === 'building')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(record.building.address), 1),
                                _hoisted_1,
                                _createTextVNode(" " + _toDisplayString(record.building.zipcode) + " " + _toDisplayString(record.building.city), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.key === 'status')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(record.status_label), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.key === 'actions')
                            ? (_openBlock(), _createBlock(_component_a_button, {
                                key: 2,
                                type: "link",
                                size: "small",
                                onClick: ($event: any) => (_unref(router).push({ name: 'IssueShow', params: { issueId: record.id.toString() } }))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Bekijken")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["dataSource", "columns"]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_2, "Er zijn geen servicemeldingen."))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_a_row, {
            key: 1,
            class: "mb-0"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  (issues.value.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(issues.value, (issue, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: issue.id
                          }, [
                            _createElementVNode("b", null, "#" + _toDisplayString(issue.id) + " - " + _toDisplayString(issue.title), 1),
                            _hoisted_4,
                            (_unref(auth).multipleObjects)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
                                  _createTextVNode(_toDisplayString(issue.building.address) + ", " + _toDisplayString(issue.building.zipcode) + " " + _toDisplayString(issue.building.city), 1),
                                  _hoisted_6
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_button, {
                              type: "link",
                              size: "small",
                              style: {"padding":"0","margin-top":"8px"},
                              onClick: ($event: any) => (_unref(router).push({ name: 'IssueShow', params: { issueId: issue.id.toString() } }))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("Bekijken")
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            (index + 1 !== issues.value.length)
                              ? (_openBlock(), _createBlock(_component_a_divider, {
                                  key: 1,
                                  style: {"margin":"16px 0"}
                                }))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_7, "Er zijn geen servicemeldingen."))
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["loading"]))
}
}

})